module.exports = __webpack_public_path__ + "img/howit-third.a46cf0f3.png";